import React, { Component } from "react";
import socketIOClient from "socket.io-client";
import { httpUploadFile, URLS, httpRequest } from "./../network";
import download from "downloadjs"
import { isNullOrEmpty, SCRAPING_PAGE_TYPE  } from "./../utils";

import './../css/pjud.css';
import './../css/sii.css';

class Sii extends Component {

    constructor() {
        super();
      
        this.state = {
            filePath: "",
            fileName: "",
            fileChoicePath: "",
            rows: [],
            rowMap: [],
            showLoader: false,
            currentRevision: "",
            selectCourt: "",
            selectMagistrate: "",
            magistrates: [],
            selectedMagistrates: [],
            maxRows: 0,
            currentRow: 0,
            cssTabRaiz: "show-tab-content",
            cssTabMap: "hide-tab-content",
            currentView: 1,
            communes: [],
            selectedCommune: -1
        }
    }

    componentDidMount() {

        this.fileSelector = this.buildFileSelector();
        httpRequest(URLS.GET_COMMUNES, null, "GET")
            .then ( (response) => {
                
                if (!response.success) {
                    console.log ("error obteniendo comunas");
                }
        
                const communes = response.data;
                this.setState({communes: communes});
            });
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }
    
    buildFileSelector = () => {
		
        const fileSelector = document.createElement("input");
        fileSelector.setAttribute("type", "file");
        fileSelector.setAttribute("multiple", "multiple");
    
        fileSelector.onchange = this.parseFile();
        return fileSelector;
    };

    parseFile = () => (e) => {

        const file = e.target.files[0];
        this.setState({fileChoicePath: file, fileName: file.name });
    };
        
    onFileClickSelect = () => (e) => {
        e.preventDefault();
        this.fileSelector.click();
    };

    downloadFileResult (filename) {

        fetch(URLS.DOWNLOAD_FILE + "?file="+filename)
            .then ((res) => {
                return res.blob();
            })
            .then ( (blob) => {

                const endFileName = this.state.currentView === 1 ?  "sii_bienes_resultado.xls" : "sii_bienes_mapa.xls";
                download(blob, endFileName, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            })
            .catch( (err) => {
                console.log (err);
            });
    }

    onSearchClick = async () => {
        
        if ( isNullOrEmpty( this.state.fileName)) {
            alert("Debes cargar primero un archivo!");
            return;
        }

        if (this.state.currentView === 2 && this.state.selectedCommune === -1) {
            alert("Debes seleccionar una comuna!");
            return;
        }

        const fileData = await httpUploadFile(URLS.UPLOAD_FILE, { newFile: this.state.fileChoicePath});
        
        const socket = socketIOClient(URLS.MAIN_URL, {  query: "type="+ SCRAPING_PAGE_TYPE.SII});
        socket.on("connection", (data) => {
            console.log (data)            
        });

        socket.on("on_row_incoming", (data) => {
            
            const json = JSON.parse(data);
        
            let currentrows = [];
            if (this.state.currentView === 1) {
                currentrows =this.state.rows;
            }
            else {
                currentrows = this.state.rowMap;
            }
            currentrows.push(json.tender);
            if (this.state.currentView === 1) {
                this.setState({ rows: currentrows, currentRevision: "Revisando Rol " + json.tender.rol});
            }
            else {
                this.setState({ rowMap: currentrows, currentRevision: "Revisando ID " + json.tender.id});
            }
        });

        socket.on ("on_process_end", (filename) => {
            
            socket.emit("disconnect");
            socket.disconnect();
            this.setState({showLoader: false, currentRevision: "", currentRow: 0});

            this.downloadFileResult(filename);
        });

        socket.on("on_rows_to_proccess", (rowsNumber) => {
            this.setState({maxRows: rowsNumber});
        })

        socket.on("on_error", (errObj) => {

            this.setState({showLoader: false, currentRevision: "", currentRow: 0});

            const err = errObj.err;
            this.props.errorMessage(err.message);
            socket.emit("disconnect");
            socket.disconnect();

            if ( !isNullOrEmpty(errObj.file)) {
                this.downloadFileResult(errObj.file);
            }
        });

        socket.on("on_current_processing", (data) => {
            this.setState({currentRevision: "Revisando " + data.rol, currentRow: data.number});
        });
        
        this.setState({rows: [], showLoader: true, fileName: fileData.realname, currentRevision: "", currentRow: 0, rowMap:[] });

        const params = { 
            path: fileData.path, 
            task: this.state.currentView, 
            commune: this.state.selectedCommune
        };

        socket.emit("process_start", params);
    }

    onChangeInput = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

    onTabClick = (choice) => (e) =>  {
        
        let nstate = {
            cssTabRaiz: "hide-tab-content", 
            cssTabMap: "show-tab-content", 
            currentView: choice,
            rows: [],
            rowMap: [],
            currentRow: 0,
            currentRevision: "",
            showLoader: false,
            fileName: "",
            maxRows: 0
        };

        if (choice === 2) {

            nstate.cssTabRaiz = "hide-tab-content";
            nstate.cssTabMap = "show-tab-content";
        }
        else {
            nstate.cssTabRaiz = "show-tab-content";
            nstate.cssTabMap = "hide-tab-content";
        }

        this.setState(nstate);
    }

    selectChange = (event) => {

        const selection = event.target.value;
        this.setState({selectedCommune: selection});    
    }

    render () {

        const firstRow = isNullOrEmpty(this.state.rowMap) && this.state.rowMap.length === 0 ? [] : this.state.rowMap[0];
        
        return (
            <div className="pjud-container">
                 <div className="sii-tab-container">
                    <input type="radio" id="tab-1" name="show" onClick={this.onTabClick(1)} />
                    <input type="radio" id="tab-2" name="show" onClick={this.onTabClick(2)} />
                    <div className="sii-tab">
                        <label htmlFor="tab-1">Bienes Raíces</label>
                        <label htmlFor="tab-2">Servicio Mapa</label>
                    </div>
                </div> 

                <div className={"sii-container " + this.state.cssTabRaiz}>
                    <h3>Servicio de Impuestos internos - Bienes raíces</h3>
                    <p>
                        Busqueda de información sobre bienes raíces según su rol y comuna. <br />
                        Se deja para descargar un archivo de ejemplo.
                        <a href={URLS.MAIN_URL + "assets/sii_ejemplo_bienes.xlsx"}>
                            <span className="fas fa-file-excel pjud-excel-icon" title="Documento de ejemplo"></span>
                        </a>
                    </p>
                    
                    <div className="pjud-option-container">
                        <fieldset className="scheduler-border" >
                            <legend className="scheduler-border">Selecciona el archivo con los Rol a buscar</legend>
                            <div className="filter-doc-file">
                                <input type="text" id="filterIdsTxt" className="form-control"
                                    placeholder="Selecciona archivo" value={this.state.fileName}/>
                                <button className="btn btn-outline-primary" onClick={this.onFileClickSelect()}> Abrir</button>
                            </div>
                        </fieldset>
                    </div>

                    <div className="progress-container">
                        {this.state.currentRevision}
                        <div className="progress-state">
                            { this.state.showLoader && <div id="loader" className="loader-seia"></div> }
                            <label id="currentProgress">{"Leido " + this.state.currentRow + " de " + this.state.maxRows}</label>
                        </div>
                        <button className="btn btn-outline-primary" onClick={this.onSearchClick}>Buscar</button>
                    </div>
                    
                    <div id="tableContainer" className="result-table">
                        <table className="table table-striped table-fixed">
                            <thead>
                                <tr>
                                    <th scope="col">Rol</th>
                                    <th scope="col">Ciudad</th>
                                    {
                                        this.state.rows.length > 0 &&
                                            Object.keys(this.state.rows[0].properties).map( (key, index) => {
                                                return <th key={index} scope="col">{key}</th>        
                                            })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.rows.map( (row, index) => {
                                        
                                        return (
                                            <tr key={index}>
                                                <td className="first-table-row">{row.rol}</td>
                                                <td >{row.city}</td>
                                                {
                                                    Object.keys(row.properties).map( (key, index) => {
                                                        return <td key={index}>{ row.properties[key]}</td>
                                                    })
                                                }
                                            </tr>
                                        );
                                    })   
                                }
                            
                            </tbody>
                        </table>
                        <div style={{ float:"left", clear: "both" }}
                            ref={(el) => { this.messagesEnd = el; }}>
                        </div>
                    </div>
                </div>

                <div className={"sii-container " + this.state.cssTabMap}>
                    <h3>Servicio de Impuestos internos - Servicio Mapa</h3>
                    <p>
                        Busqueda de información sobre bienes raíces datos de lat/lng obtenidos desde ArcMap. <br />
                        Se deja para descargar un archivo de ejemplo.
                        <a href={URLS.MAIN_URL + "assets/sii_ejemplo_mapa.xls"}>
                            <span className="fas fa-file-excel pjud-excel-icon" title="Documento de ejemplo"></span>
                        </a>
                    </p>
                    <div className="pjud-option-container">
                        <fieldset className="scheduler-border" >
                            <legend className="scheduler-border">Selecciona el archivo con lat/lng a buscar</legend>
                            <div className="filter-doc-file">
                                <input type="text" id="filterIdsTxt" className="form-control"
                                    placeholder="Selecciona archivo" value={this.state.fileName}/>
                                <button className="btn btn-outline-primary" onClick={this.onFileClickSelect()}> Abrir</button>
                            </div>
                            
                        </fieldset>
                        <div className="local-browser-option">
                            Comunas
                            <select onChange={this.selectChange} >
                                <option value="-1">Selecciona Comuna</option>
                                {
                                    this.state.communes.map( (commune) => {
                                        return (<option value={commune.code}>{commune.territory}</option>)
                                    })
                                }
                            </select>
                           
                        </div>
                    </div>

                    <div className="progress-container">
                        {this.state.currentRevision}
                        <div className="progress-state">
                            { this.state.showLoader && <div id="loader" className="loader-seia"></div> }
                            <label id="currentProgress">{"Leido " + this.state.currentRow + " de " + this.state.maxRows}</label>
                        </div>
                        <button className="btn btn-outline-primary" onClick={this.onSearchClick}>Buscar</button>
                    </div>

                    <div id="tableContainer" className="result-table">
                        <table className="table table-striped table-fixed">
                            <thead>
                                <tr>
                                   
                                   { 
                                        !isNullOrEmpty(firstRow) &&
                                            Object.keys(firstRow.properties).map( (key, index) => {
                                                return <th key={index}>{ key}</th>
                                            })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.rowMap.map( (row, index) => {
                                        
                                        return (
                                            <tr key={index}>
                                                {
                                                    Object.keys(row.properties).map( (key, index) => {
                                                        return <td key={index}>{ row.properties[key]}</td>
                                                    })
                                                }                                               
                                            </tr>
                                        );
                                    })   
                                }
                            
                            </tbody>
                        </table>
                        <div style={{ float:"left", clear: "both" }}
                            ref={(el) => { this.messagesEnd = el; }}>
                        </div>
                    </div>

                </div>
                
            </div>
        );
    }
    
}

export default Sii;
